import { ContentWrapper, Loader, TabPanel, Tabs } from 'components';
import { decodeJwt } from 'jose';
import { isEmpty } from 'lodash/fp';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  getChangeProfileSettingsLoading,
  getFullAuthUser,
} from 'store/selectors/auth';
import validate from 'uuid-validate';

import ChangeEmail from './ChangeEmail';
import ChangePassword from './ChangePassword';
import Languages from './Language';
import Notification from './Notification';
import Other from './Other';
import Permissions from './Permissions';
import { Content, Header, StyledFloatingLoader } from './styled';
import TimeFormat from './TimeFormat';

const UserProfileSettingsPage = () => {
  const { t } = useTranslation();
  const user = useSelector(getFullAuthUser);
  const loading = useSelector(getChangeProfileSettingsLoading);
  const decoded = decodeJwt(user?.idToken);
  const canChangeCredentials = decoded && validate(decoded['cognito:username']);

  if (isEmpty(user)) {
    return <Loader />;
  }

  return (
    <ContentWrapper minHeight="auto">
      {loading && (
        <StyledFloatingLoader>
          <Loader size="60px" type={null} />
        </StyledFloatingLoader>
      )}
      <Header>{t('profileSettings.title')}</Header>
      <Content>
        <Tabs variant="navigation" navigationLayout="panel">
          <TabPanel label={t('profileSettings.notification')}>
            <Notification />
          </TabPanel>
          {canChangeCredentials ? (
            <TabPanel label={t('profileSettings.changeEmail')}>
              <ChangeEmail />
            </TabPanel>
          ) : null}
          {canChangeCredentials ? (
            <TabPanel label={t('profileSettings.changePassword')}>
              <ChangePassword />
            </TabPanel>
          ) : null}
          <TabPanel label={t('profileSettings.language')}>
            <Languages />
          </TabPanel>
          <TabPanel label={t('profileSettings.timeFormat')}>
            <TimeFormat />
          </TabPanel>
          <TabPanel label={t('profileSettings.permissions')}>
            <Permissions />
          </TabPanel>
          <TabPanel label={t('profileSettings.other')}>
            <Other />
          </TabPanel>
        </Tabs>
      </Content>
    </ContentWrapper>
  );
};

export default UserProfileSettingsPage;
